import type { SettingsGroup } from '../../../../queries/skill-administration';

export interface SettingsAdministration {
  status: 'idle' | 'loading' | 'ready' | 'error';
  /** Discovered manageable teams whose parent is an eligible organization. */
  teams: readonly SettingsGroup[];
  managedRoots: readonly SettingsGroup[];
  /** Fresh admin UUIDs keyed by their root group, independent of remembered navigation. */
  rootAdmins: Readonly<Record<string, readonly string[]>>;
  /** Organizations where the current user is a direct admin or manager. */
  organizations: readonly SettingsGroup[];
  /** Navigation visibility may be remembered; only current query results supply groups and membership. */
  showTeams: boolean;
  showAdmins: boolean;
  hasNavigationHint: boolean;
  retry: () => void;
}

export const DISABLED_SETTINGS_ADMINISTRATION: SettingsAdministration = {
  status: 'idle',
  teams: [],
  managedRoots: [],
  rootAdmins: {},
  organizations: [],
  showTeams: false,
  showAdmins: false,
  hasNavigationHint: false,
  retry: () => undefined,
};
